/*
 * Copyright (c) 2023 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Inject, Injectable, inject } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { ExceptionService } from '../service/exception.service';
import { ErrorWrapper } from './error-wrappers/error.wrapper';
import { ExceptionEntity } from '../exception.model';

@Injectable({
  providedIn: 'root',
})
export class ErrorsService {
  private readonly exceptionService = inject(ExceptionService);

  /* eslint-disable @angular-eslint/prefer-inject -- inject() cannot type a multi-provider bound to a class token (the injector returns an array of them) */
  constructor(@Inject(ErrorWrapper) private readonly errorWrappers: ErrorWrapper[]) {}
  /* eslint-enable @angular-eslint/prefer-inject */


  prepareAndSaveException(
    error: HttpErrorResponse | Error | any,
    systemName: any,
    createdBy: any
  ) {
    let exception: ExceptionEntity | null = null;
    for (const errorWrapper of this.errorWrappers) {
      if (errorWrapper.canTransform(error)) {
        exception = errorWrapper.transform(error);
      }
    }

    if (exception == null) {
      exception = new ExceptionEntity();
      exception.stackTrace = JSON.stringify(error);
    }

    exception.systemName = systemName;
    exception.createdBy = createdBy;

    this.exceptionService.saveException(exception).subscribe(() => {
      console.log('Exception saved');
    });
  }
}
